import {  useEffect } from "react";
import { BrowserRouter, Routes, Navigate, Route } from "react-router-dom";
import { Container } from "react-bootstrap"; // React-Bootstrap components
import "./App.css"; // Custom CSS
import "react-toastify/dist/ReactToastify.css"; // Import the CSS for toasts
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from "react-toastify";

// Components
import Sidebar from "./components/userComponents/Sidebar.js";
import Dashboard from "./components/userComponents/Dashboard.js";
import ProfilePage from "./components/userComponents/Profile.js";
import DepositWithdraw from "./components/userComponents/Banking.js";
import OrderHistoryPage from "./components/userComponents/History.js";
import LoginPage from "./components/userComponents/Login.js";
import AdminLogin from "./components/adminComponents/AdminLogin.js";
import SuperAdminLogin from "./components/superAdminComponents/SuperAdminLogin.js";
import RegisterForm from "./components/userComponents/Register.js";
import TradeGraph from "./components/userComponents/TradingViewWidget.js";
import ProtectedRoute from "./services/ProtectedRoutes.js";
import PublicRoute from "./services/PublicRoutes.js";
import EmailVerify from "./components/userComponents/EmailVerify.js";
import AdminEmailVerify from "./components/adminComponents/AdminEmailVerify.js";
import AdminDashboard from "./components/adminComponents/Dashboard.js";
import SuperAdminDashboard from "./components/superAdminComponents/Dashboard.js";
import Header from "./components/userComponents/Header.js";
import ForgotPassword from "./components/userComponents/forgotpassword.js";
import AdminForgotPassword from "./components/adminComponents/adminforgotpassword.js";
import SuperAdminForgotPassword from "./components/superAdminComponents/superAdminForgotpassword.js";
import ResetPassword from "./components/userComponents/ResetPassword.js";
import AdminResetPassword from "./components/adminComponents/ResetPassword.js";
import SuperAdminResetPassword from "./components/superAdminComponents/ResetPassword.js";
import ProtectedAdminRoute from "./services/ProtectedAdminRoutes.js";
import ProtectedSuperAdminRoute from "./services/ProtectedSuperAdminRoutes.js";
import Unauthorized from "./components/userComponents/Unauthorized.js";
import Footer from "./components/userComponents/Footer.js";
import SetCurrencyRate from "./components/adminComponents/SetCurrencyRate.js";
import AdminHeader from "./components/adminComponents/AdminHeader.js";
import AdminProfile from "./components/adminComponents/AdminProfile.js";
import CurrexAdminDashboard from "./components/adminComponents/CurrexAdminDashboard.js";
import TradingDashboard from "./components/MetaGen/TradingDashboard.js";
import UserLoginDetails from "./components/superAdminComponents/UserLoginDetails.js";
import Admin from "./components/superAdminComponents/Admin.js";
import AdminLoginDetails from "./components/superAdminComponents/AdminLoginDetails.js";
import SuperAdminProfile from "./components/superAdminComponents/SuperAdminProfile.js";
import Referral from "./components/userComponents/profile-tabs/Referral.js";
import AgreementDashboard from "./components/superAdminComponents/Agreements/Dashboard.js";
import AdminAgreementDashboard from "./components/adminComponents/Agreements/Dashboard.js";
import PartialWithdraws from "./components/userComponents/PartialWithdraws.js";





 
const ProtectedLayout = ({ children }) => (
  
  <Container fluid className="p-0">
    <Header page="dashboard" />
    <main style={{ display: "flex" }}>
     
      <Sidebar />
    
      <div className="app" >
        {children}
      </div>
    </main>
    <Footer />
  </Container>
  
);

const App = () => {

  // Tidio chat script=======
  useEffect(() => {
    const tidioScript = document.createElement("script");
    tidioScript.src = "//code.tidio.co/4ts4atz6pz9vfxlcxh9zqeobjg1zwvyw.js";
    tidioScript.async = true;
    document.body.appendChild(tidioScript);
  
    return () => {
      document.body.removeChild(tidioScript);
    };
  }, []);

  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes>
        <Route path="/unauthorized" element={<Unauthorized />} />

        {/* Public Routes */}
        <Route element={<PublicRoute />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/adminlogin" element={<AdminLogin />} />
          <Route path="/superadminlogin" element={<SuperAdminLogin />} />
          <Route path="/register/:referralID?" element={<RegisterForm />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
          <Route path="/superadmin/forgot-password" element={<SuperAdminForgotPassword />} />
          <Route path="/resetPassword/:resetToken" element={<ResetPassword />} />
          <Route path="/admin/resetPassword/:resetToken" element={<AdminResetPassword />} />
          <Route path="/superadmin/resetPassword/:resetToken" element={<SuperAdminResetPassword />} />
          <Route path="/verifyEmail/:emailVerifyToken" element={<EmailVerify show={true} handleClose={()=>{}}/>} />
          <Route path="/admin/verifyEmail/:emailVerifyToken" element={<AdminEmailVerify show={true} handleClose={()=>{}}/>} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Route>

        {/* Private Routes */}
        <Route element={<ProtectedRoute />}>
        {/* <Route> */}
          <Route path="/dashboard" element={<ProtectedLayout><Dashboard /></ProtectedLayout>} />
          <Route path="/referral" element={<ProtectedLayout><Referral /></ProtectedLayout>} />
          <Route path="/profile" element={<ProtectedLayout><ProfilePage /></ProtectedLayout>} />
          <Route path="/bank" element={<ProtectedLayout><DepositWithdraw /></ProtectedLayout>} />
          <Route path="/history" element={<ProtectedLayout><OrderHistoryPage /></ProtectedLayout>} />
          <Route path="/tradingwidget" element={<ProtectedLayout><TradeGraph /></ProtectedLayout>} />
          <Route path="/partialWithdraws" element={<ProtectedLayout><PartialWithdraws /></ProtectedLayout>} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
          <Route path="/tradingdashboard" element={<ProtectedLayout><TradingDashboard/></ProtectedLayout>} />

        </Route>

      <Route element={<ProtectedAdminRoute />}>  
        {/* <Route> */}
          <Route path="/adminDashboard" element={<ProtectedLayout><AdminDashboard /></ProtectedLayout>} /> 
          <Route path="/currexadmindashboard" element={<ProtectedLayout><CurrexAdminDashboard /></ProtectedLayout>} />
          <Route path="/setcurrencyrate" element={<ProtectedLayout><SetCurrencyRate /></ProtectedLayout>} /> 
          <Route path="/adminheader" element={<ProtectedLayout><AdminHeader /></ProtectedLayout>} /> 
          <Route path="/adminprofile" element={<ProtectedLayout><AdminProfile /></ProtectedLayout>} />
          <Route path="/adminloanagreement" element={<ProtectedLayout><AdminAgreementDashboard/></ProtectedLayout>} />
          <Route path="*" element={<Navigate to="/unauthorized" />} />
      </Route>


      {/* ------------super admin routes-------------------- */}
      <Route element={<ProtectedSuperAdminRoute />}>
        {/* <Route> */}
          <Route path="/superadmindashboard" element={<ProtectedLayout><SuperAdminDashboard /></ProtectedLayout>} />
          <Route path="/admin" element={<ProtectedLayout><Admin/></ProtectedLayout>} />
          <Route path="/superadminprofile" element={<ProtectedLayout><SuperAdminProfile /></ProtectedLayout>} />
          <Route path="/userlogindetails" element={<ProtectedLayout><UserLoginDetails /></ProtectedLayout>} />
          <Route path="/adminlogindetails" element={<ProtectedLayout><AdminLoginDetails /></ProtectedLayout>} />
          <Route path="/superadmin/loanagreement" element={<ProtectedLayout><AgreementDashboard/></ProtectedLayout>} />
          <Route path="*" element={<Navigate to="/unauthorized" />} />
      </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;